import React from 'react';
import PropTypes from 'prop-types';
import Heading from '@tds/core-heading';
import HairlineDivider from '@tds/core-hairline-divider';
import DimpleDivider from '@tds/core-dimple-divider';
import Box from '@tds/core-box';
import queryString from 'query-string';

import { apiHost } from '../utils/request';
import ValidateLoader from '../UI/validateLoader';
import Loading from './loading';

import { ContentWrapper } from '../design/css';
import { useLocalizedStringsContext } from '../context/LocalizedStringsContext';

const ViewSignedContract = ({ location: { search } }) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    contractSignature: { header, loadingMessage }
  } = localizedStrings;
  const { id: orderId } = queryString.parse(search);
  const getContractUrl = id => `${apiHost}/orders/${id}/contract-pdf`;

  return !orderId ? (
    <Loading isVisible>
      <ValidateLoader message={loadingMessage} />
    </Loading>
  ) : (
    <>
      <Box between={4}>
        <HairlineDivider />
        <HairlineDivider />
      </Box>
      <div className="container 85%">
        <ContentWrapper>
          <Heading level="h2">{header}</Heading>
          <DimpleDivider />
          <embed
            src={getContractUrl(orderId)}
            type="application/pdf"
            width="100%"
            height="600px"
          />
          <DimpleDivider />
        </ContentWrapper>
      </div>
    </>
  );
};

ViewSignedContract.propTypes = {
  location: PropTypes.objectOf(PropTypes.string).isRequired
};

export default ViewSignedContract;
